import { useState, useEffect, useMemo } from 'react';
import { Image, Text } from '@ui/atoms';
import FdComparisonTable from '@components/Products/FixedDeposits/ComparisonTable/FdComparisonTable';
import Button from '@ui/atoms/design-system/Button';
import Notes from '@components/Products/FixedDeposits/ComparisonTable/Notes';
import { fdDefaultCompareContent } from '@components/Products/FixedDeposits/utils/helper';
import { cn } from '@ui/atoms/utils/utils';
import { ChevronDownIcon } from '@heroicons/react/outline';

const FDInterestRateComparison = ({ fdCompareContent }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const visibleData = useMemo(() => {
        const tableData = fdCompareContent?.tableData;
        return isMobile && !isExpanded ? tableData.slice(0, 4) : tableData;
    }, [isMobile, isExpanded, fdCompareContent]);

    return (
        <section className="bg-fd-compare-gradient">
            <div className="pt-8 px-4 max-w-[1082px] w-full mx-auto xl:py-10 flex flex-col gap-4 md:gap-8 xl:px-0">
                <div className="flex flex-col gap-4">
                    <Text
                        content={fdDefaultCompareContent?.title}
                        className="text-center h4-semibold md:h3-semibold xl:h2-semibold text-primary-500"
                        htmlTag="h2"
                    />
                </div>
                <FdComparisonTable
                    isMobile={isMobile}
                    data={visibleData}
                    isExpanded={isExpanded}
                    fdCompareContent={fdCompareContent?.tableData}
                />

                {/* Mobile "View All" Button */}
                {isMobile && (
                    <div className="mx-auto text-center">
                        <Button
                            buttonText={isExpanded ? 'View Less' : 'View All'}
                            onClick={() => setIsExpanded(!isExpanded)}
                            buttonType="ghost"
                            buttonSize="extraSmall"
                            prefixComponent={
                                <ChevronDownIcon
                                    className={cn(
                                        'w-4 h-4 transform transition-transform',
                                        {
                                            'rotate-180': isExpanded,
                                        }
                                    )}
                                />
                            }
                        />
                    </div>
                )}

                {/* Notes Section */}
                <Notes
                    note1={fdCompareContent?.note1}
                    note2={fdCompareContent?.note2}
                />
            </div>
        </section>
    );
};

export default FDInterestRateComparison;
